import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { UsersFacade } from '@galabid/gb-dashboard/user/data-access'
import * as UsersActions from 'libs/gb-dashboard/user/data-access/src/lib/+state/users.actions'

@Component({
  selector: 'gb-message-user',
  templateUrl: './gb-message-user.component.html',
  styleUrls: ['./gb-message-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbMessageUserComponent implements OnDestroy {
  messageLoaded$ = this.usersFacade.messageLoaded$

  messageUserFormFields = {
    message_template: new FormControl('', [Validators.required]),
  }

  messageUserForm = new FormGroup(this.messageUserFormFields)

  get message_template() {
    return this.messageUserForm.get('message_template')
  }

  dialogData: {
    profile: string
  }

  constructor(
    @Inject(MAT_DIALOG_DATA)
    data: {
      profile: string
    },
    private usersFacade: UsersFacade,
  ) {
    this.dialogData = data
  }

  submitForm() {
    this.messageUserForm.valid ? this.submitMessage() : this.onError()
  }

  submitMessage() {
    if (this.message_template?.value)
      this.usersFacade.dispatch(
        UsersActions.messageUser({
          profile: this.dialogData.profile,
          message_template: this.message_template.value,
        }),
      )
  }

  onError() {
    this.messageUserForm.markAllAsTouched()
  }

  ngOnDestroy(): void {
    this.usersFacade.dispatch(UsersActions.clearSelectedUser())
  }
}
